export const Mode = {
  Prod: 'production',
  Hml: 'staging',
  Dev: 'development',
  Test: 'test',
}
